'use client';

import { useEffect, useRef } from 'react';
import { trackPageViewMetaData, resetMetadataTracking } from './engagementAnalytics';

export default function ContentEngagementClient({ metaData }: { metaData: any }) {
  const lastTrackedUrl = useRef<string>('');

  useEffect(() => {
    if (!metaData) {
      console.log('[ContentEngagementClient] No metadata provided');
      return;
    }
    
    const currentUrl = metaData.url || (typeof window !== 'undefined' ? window.location.pathname : '');
    
    // Check if this is a new page based on URL
    if (lastTrackedUrl.current === currentUrl) {
      console.log('[ContentEngagementClient] Already tracked for URL:', currentUrl);
      return;
    }

    console.log('[ContentEngagementClient] Waiting for analytics to load for URL:', currentUrl);
    
    // Mark as tracked immediately to prevent race conditions
    lastTrackedUrl.current = currentUrl;
    
    // Wait for Segment Analytics to be available before tracking
    const waitForAnalytics = (attempts = 0, maxAttempts = 50) => {
      if (typeof window === 'undefined') return;
      
      // Check if analytics is loaded
      if (window.analytics?.track) {
        console.log('[ContentEngagementClient] ✓ Analytics loaded, tracking metadata');
        console.log('[ContentEngagementClient] Metadata:', metaData);
        
        // Reset global tracking state and track new page
        resetMetadataTracking();
        trackPageViewMetaData(metaData);
        return;
      }
      
      // Retry if not loaded yet
      if (attempts < maxAttempts) {
        console.log(`[ContentEngagementClient] Analytics not ready, waiting... (${attempts + 1}/${maxAttempts})`);
        setTimeout(() => waitForAnalytics(attempts + 1, maxAttempts), 100);
      } else {
        console.error('[ContentEngagementClient] ✗ Analytics failed to load after 5 seconds');
        console.log('[ContentEngagementClient] Segment script may be commented out in layout.tsx');
      }
    };
    
    waitForAnalytics();
  }, [metaData]);

  return null;
}